import React from "react";
import { TitleThickThin } from "@components/titles";
import styled from "@emotion/styled";
import SliderCollectionProperty from "@components/slider-collection-property";
import Link from "next/link";
import Button from "@components/Button";
import { CPagesPath } from "shared/models/const/pages-path";
import { useTranslations } from "next-intl";
import WsSectionTitleWithThinTitle from "@components/a1-refactor/typography/WsSectionTitleWithThinTitle copy";
import { Grid } from "@mui/material";
function FeaturedProperty() {
  const translation = useTranslations("collection.outstandingProperties");

  const featuredTitle = translation("title") || "";

  const [title, ...rest] = featuredTitle.split(" ");

  return (
    <ContainerFeaturedProperty>
      {/* <TitleThickThin
        thinTitle={rest.join(" ")}
        thickTitle={title}
        color="--color-brand-bg-secondary"
      ></TitleThickThin> */}
      <Grid item xs={12} mb={4}>
        <WsSectionTitleWithThinTitle
          title={rest.join(" ")}
          subtitle={title}
          color="white"
        ></WsSectionTitleWithThinTitle>
      </Grid>

      <SliderCollectionProperty></SliderCollectionProperty>
      <CollectionButton>
        <Link href={CPagesPath.es.collection_properties} passHref>
          <Button component="a">{translation("seeMore")}</Button>
        </Link>
      </CollectionButton>
    </ContainerFeaturedProperty>
  );
}

export default FeaturedProperty;
const CollectionButton = styled.article`
  width: 100%;
  margin: auto;
  margin-top: 50px;
  display: flex;
  justify-content: center;
`;

const ContainerFeaturedProperty = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 150px;
  & h2 {
    padding-bottom: 10px;
  }
  @media screen and (max-width: 600px) {
    margin-top: 100px;
  }
`;
